export default __webpack_public_path__ + "static/media/digital-journey-studio-logo.03b4c130.png";